import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  perfReviewItemList: {
    requesting: false,
    items: [],
    pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
    error: null,
    success: false,
    filters: {},
  },
  perfReviewItemDetails: {
    requesting: false,
    data: null,
    error: null,
    success: false,
  },
  monthlyPerfReviewItems: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  },
}

export const perfReviewItemSlice = createSlice({
  name: 'performanceReviewItem',
  initialState,
  reducers: {
    getPerfReviewItemList: (state, action) => {
      state.perfReviewItemList.requesting = true
      state.perfReviewItemList.error = null
      state.perfReviewItemList.items = []
      state.perfReviewItemList.success = false
      state.perfReviewItemList.filters = action.payload
    },
    getPerfReviewItemListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload
      state.perfReviewItemList.requesting = false
      state.perfReviewItemList.items = data
      state.perfReviewItemList.success = true
      state.perfReviewItemList.pagination.current_page = current_page
      state.perfReviewItemList.pagination.per_page = per_page
      state.perfReviewItemList.pagination.total = total
    },
    getPerfReviewItemListFail: (state, action) => {
      state.perfReviewItemList.requesting = false
      state.perfReviewItemList.error = action.payload
    },
    getPerfReviewItemDetails: (state) => {
      state.perfReviewItemDetails.requesting = true
      state.perfReviewItemDetails.error = null
      state.perfReviewItemDetails.data = null
      state.perfReviewItemDetails.success = false
    },
    getPerfReviewItemDetailsSuccess: (state, action) => {
      state.perfReviewItemDetails.requesting = false
      state.perfReviewItemDetails.data = action.payload
      state.perfReviewItemDetails.success = true
    },
    getPerfReviewItemDetailsFail: (state, action) => {
      state.perfReviewItemDetails.requesting = false
      state.perfReviewItemDetails.error = action.payload
    },
    doPerfReviewItemCreate: (state) => {
      state.perfReviewItemDetails.requesting = true
      state.perfReviewItemDetails.error = null
      state.perfReviewItemDetails.data = null
      state.perfReviewItemDetails.success = false
    },
    doPerfReviewItemUpdate: (state) => {
      state.perfReviewItemDetails.requesting = true
      state.perfReviewItemDetails.error = null
      state.perfReviewItemDetails.data = null
      state.perfReviewItemDetails.success = false
    },
    doPerfReviewItemDelete: (state) => {
      state.perfReviewItemDetails.requesting = true
      state.perfReviewItemDetails.error = null
      state.perfReviewItemDetails.data = null
      state.perfReviewItemDetails.success = false
    },

    getMonthlyPerfReviewItems: (state, action) => {
      state.monthlyPerfReviewItems.requesting = true
      state.monthlyPerfReviewItems.error = null
      state.monthlyPerfReviewItems.items = []
      state.monthlyPerfReviewItems.success = false
      state.monthlyPerfReviewItems.filters = action.payload
    },
    getMonthlyPerfReviewItemsSuccess: (state, action) => {
      state.monthlyPerfReviewItems.requesting = false
      state.monthlyPerfReviewItems.items = action.payload
      state.monthlyPerfReviewItems.success = true
    },
    getMonthlyPerfReviewItemsFail: (state, action) => {
      state.monthlyPerfReviewItems.requesting = false
      state.monthlyPerfReviewItems.error = action.payload
    },

    
  },
})

export const {
  getPerfReviewItemList, getPerfReviewItemListSuccess, getPerfReviewItemListFail, 
  getPerfReviewItemDetails, getPerfReviewItemDetailsSuccess, getPerfReviewItemDetailsFail, 
  doPerfReviewItemCreate, doPerfReviewItemUpdate, doPerfReviewItemDelete,
  getMonthlyPerfReviewItems, getMonthlyPerfReviewItemsSuccess, getMonthlyPerfReviewItemsFail
} = perfReviewItemSlice.actions

export default perfReviewItemSlice.reducer
